import { Trans, useTranslation } from 'next-i18next/pages';
import React from 'react';

import { useFlavorFromRoute } from '@pflegia/ui/hooks/use-flavor-from-route';
import Headline from '@pflegia/ui/shared/headline/Headline';

export interface HeadlineProps {
  arrowPosition?: 'left' | 'right';
  Component?: keyof React.JSX.IntrinsicElements;
  i18nKey: string;
  showArrow?: boolean;
  subTitle?: string;
  subTitleValues?: Record<string, unknown>;
  subTitleClassName?: string;
  titleClassName?: string;
  titleValues?: Record<string, string>;
}

const PflegiaHeadline: React.FC<HeadlineProps> = ({
  arrowPosition,
  Component,
  i18nKey,
  showArrow,
  subTitle,
  subTitleClassName,
  subTitleValues,
  titleClassName,
  titleValues,
}) => {
  const { t } = useTranslation();
  const { isPraxia, sourceDomainName } = useFlavorFromRoute();
  return (
    <Headline
      titleClassName={titleClassName}
      subTitleClassName={subTitleClassName}
      Component={Component}
      title={
        <Trans
          components={{ span: <span className='font-handwriting text-main-blue align-text-top text-3xl whitespace-nowrap md:text-5xl' /> }}
          i18nKey={`${i18nKey}${isPraxia ? 'Praxia' : ''}`}
          defaults={t(i18nKey)}
          values={{ ...titleValues, domain: sourceDomainName }}
          t={t}
        />
      }
      subTitle={
        subTitle ? (
          <Trans
            components={{ span: <span className='text-main-blue' /> }}
            i18nKey={subTitle}
            defaults={t(subTitle)}
            t={t}
            values={{ ...subTitleValues, domain: sourceDomainName }}
          />
        ) : undefined
      }
      showArrow={showArrow}
      arrowPosition={arrowPosition}
    />
  );
};

export default PflegiaHeadline;
